import { getEditableField } from '../store/selectors';
export var validateAudiences = function (params) {
    var state = params.store.getState();
    var isValid = true;
    var errors = [];
    var usesCustomAudiencesField = getEditableField(state, 'usesCustomAudiences');
    if (usesCustomAudiencesField.value) {
        var isAtLeastOneAudienceSelected = false;
        var audienceFields = getEditableField(state, 'audiences').value;
        var isLapsingEnabled = audienceFields.lapsing.enabled;
        var isProspectiveEnabled = audienceFields.prospective.enabled;
        var isRegularEnabled = audienceFields.regular.enabled;
        var isServiceEnabled = audienceFields.service.enabled;
        var isNewClientsEnabled = audienceFields.newClients.enabled;
        var isAtLeastOneBarberAudienceEnabled = Object.values(audienceFields.barbers).some(function (barber) { return barber.enabled; });
        var isAtLeastOneShopAudienceEnabled = Object.values(audienceFields.shops).some(function (shop) { return shop.enabled; });
        isAtLeastOneAudienceSelected =
            isLapsingEnabled ||
                isProspectiveEnabled ||
                isRegularEnabled ||
                isServiceEnabled ||
                isNewClientsEnabled ||
                isAtLeastOneBarberAudienceEnabled ||
                isAtLeastOneShopAudienceEnabled;
        if (!isAtLeastOneAudienceSelected) {
            isValid = false;
            errors.push({
                field: 'audiences',
                message: 'Please select at least one audience.',
            });
        }
    }
    return {
        isValid: isValid,
        errors: errors,
    };
};
